<template>
  <!-- <v-card-text> -->
  <v-flex style="font-size: 15px">
    <!-- <v-text-field disabled hide-details label="Store name" v-model="info.store_name"></v-text-field> -->
    <!-- <v-card color="green"> -->
    <v-list class="pb-0">
      <v-card>
        <v-card flat color="grey lighten-3">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>
                <v-icon>place</v-icon>
                {{ info.store_name }}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action style="position: absolute; right: 40px">
              <v-tooltip top>
                <v-icon
                  slot="activator"
                  :color="filterdCheckPoint ? 'green' : 'grey'"
                  >{{ filterdCheckPoint ? "check_circle" : "schedule" }}</v-icon
                >
                <span>Status</span>
              </v-tooltip>
            </v-list-tile-action>
            <v-list-tile-action>
              <v-tooltip top>
                <v-icon
                  slot="activator"
                  :color="filterdCheckPoint ? 'green' : 'grey'"
                  @click="$emit('viewIMG', filterdImagePosition)"
                  >image</v-icon
                >
                <span>View image</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
        </v-card>
        <v-card-text class="pt-0">
          <!-- <v-layout>
            <v-flex xs6 class="mr-2" style="position:relative;border-bottom:1px solid #757575">
              <v-text-field
                slot="activator"
                v-model="transfer_date[index].date"
                label="Transfer date"
                readonly
                hide-details
                v-if="order_status_id == 6 || order_status_id == 7"
                :disabled="isEditOrder"
              ></v-text-field>
              <v-menu
                :close-on-content-click="false"
                v-model="menu2"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                v-if="transfer_date.length != 0 && order_status_id != 6 && order_status_id != 7"
              >
                <v-text-field
                  slot="activator"
                  v-model="transfer_date[index].date"
                  label="Transfer date"
                  readonly
                  hide-details
                  clearable
                    :disabled="isEditOrder"
                ></v-text-field>
                <v-date-picker
                  :min="moment().format('YYYY-MM-DD')"
                  v-model="transfer_date[index].date"
                  color="#333"
                  no-title
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex
              xs6
              class="text-xs-left"
              style="position:relative;border-bottom:1px solid #757575"
            >
              <span
                style="font-size:12px;color:grey;top:5px;position:absolute;"
                v-if="order_status_id != 6 && order_status_id != 7"
              >Transfer time</span>
              <v-text-field
                slot="activator"
                :value="transfer_time[index].HH + ':' + transfer_time[index].mm"
                label="Transfer time"
                readonly
                hide-details
                  :disabled="isEditOrder"
                v-if="order_status_id == 6 || order_status_id == 7"
              ></v-text-field>
              <vue-timepicker
                v-if="transfer_time.length != 0 && order_status_id != 6 && order_status_id != 7"
                format="HH:mm"
                v-model="transfer_time[index]"
                style="top:17px;position:absolute;left:0px;width:262px;"
              ></vue-timepicker>
            </v-flex>
          </v-layout>-->
          <v-textarea
            v-if="order_status_id != 6 && order_status_id != 7"
            v-model="info.store_note"
            hide-details
            rows="2"
            label="Note to store: "
            :disabled="isEditOrder"
          ></v-textarea>
          <div
            class="text-xs-left mt-2"
            v-if="
              (order_status_id == 6 &&
                $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3)
            "
          >
            <label class="field-disable-title">Note to store:</label>
            <br />
            <div class="field-disable-data">{{ info.store_note }}</div>
          </div>
        </v-card-text>
      </v-card>
    </v-list>
    <v-card>
      <v-card-text>
        <div class="text-xs-left" style="font-size: 15px; padding-bottom: 0">
          <v-flex>
            Store tel. :
            <span v-for="(info, index) in filterdStoreTel" :key="index">{{
              info.tel + (index == filterdStoreTel.length - 1 ? "" : ",")
            }}</span>
          </v-flex>
          <v-flex>Address : {{ filterdAddress }}</v-flex>
          <v-flex>Place note : {{ filterdPlaceNote }}</v-flex>
        </div>
      </v-card-text>
    </v-card>
    <!-- </v-card> -->
  </v-flex>
  <!-- </v-card-text> -->
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapState, mapGetters } from "vuex";
export default {
  props: [
    "info",
    "transfer_date",
    "transfer_time",
    "index",
    "order_detail_position",
  ],
  data() {
    return {
      menu2: false,
    };
  },
  computed: {
    ...mapState({
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    filterdImagePosition() {
      for (let val of this.order_detail_position) {
        if (val.position_name == this.info.store_name) {
          return {
            img: val.position_image_check_point,
            place_name: val.position_name,
          };
        }
      }
    },
    filterdStoreTel() {
      for (let val of this.order_detail_position) {
        if (val.position_name == this.info.store_name) {
          return val.position_contact_tel;
        }
      }
    },
    filterdAddress() {
      for (let val of this.order_detail_position) {
        if (val.position_name == this.info.store_name) {
          return val.position_detail;
        }
      }
    },
    filterdCheckPoint() {
      for (let val of this.order_detail_position) {
        if (val.position_name == this.info.store_name) {
          return (
            val.position_order_status == 5 || val.position_order_status == 6
          );
        }
      }
    },
    filterdPlaceNote() {
      for (let val of this.order_detail_position) {
        if (val.position_name == this.info.store_name) {
          return val.position_note;
        }
      }
    },
  },
  components: {
    VueTimepicker,
  },
};
</script>

<style scoped>
.field-disable-title {
  color: grey;
  font-size: 12px;
}
.field-disable-data {
  color: grey;
  font-size: 16px;
}
</style>
